'use client';

import { CheckButton } from '@egalite/ui/Buttons/Button.old';
import Icon from '../../Icon';
import cn from '../../Utils/cn';
import { FC, useId, useState } from 'react';
import Typography from '../../Typography';

type SubOption = {
	value: string;
	label: string;
};

type Option = {
	value: string;
	label: string;
	subOptions?: SubOption[];
};

type Props = {
	options: Option[];
	setSelected: (value: string[]) => void;
	selected: string[];
	title: string;
	collapsible?: boolean;
	onChange?: (education: any, subOption: any) => void;
};

const FilterCheckboxSection: FC<Props> = ({ options, title, selected, collapsible = true, setSelected, onChange }) => {
	const [open, setOpen] = useState(true);

	const collapseId = useId();
	const sectionId = useId();

	const handleOptionChange = (value: string, subOptions?: SubOption[]) => {
		if (selected.includes(value)) {
		  // Remove a opção principal e suas subopções (se houver)
		  const updatedSelected = selected.filter(item =>
			item !== value && !subOptions?.some(subOption => item === `${value}-${subOption.value}`)
		  );
		  setSelected(updatedSelected);
		} else {
		  // Adiciona a opção principal e suas subopções (se houver)
		  const newSelected = [value];
		  if (subOptions) {
			newSelected.push(...subOptions.map(subOption => `${value}-${subOption.value}`));
		  }
		  setSelected([...selected, ...newSelected]);
		}
	  };
	
	  const handleSubOptionChange = (mainOption: string, subOption: string) => {
		if (onChange) {
			onChange(mainOption, subOption);
			return;
		}

		const combinedValue = `${mainOption}-${subOption}`;
		if (selected.includes(combinedValue)) {
		  // Remove a subopção
		  setSelected(selected.filter(item => item !== combinedValue));
		} else {
		  // Adiciona a subopção
		  setSelected([...selected, combinedValue]);
		}
	  };

	return (
		<div className="gap-16 flex flex-col pb-16">
			{collapsible ? <button
				className="text-lg font-bold flex justify-between w-full select-none text-base-grey-5"
				onClick={() => setOpen(!open)} aria-controls={sectionId} aria-expanded={open} id={collapseId}
			>
				{title}
				<Icon name={open ? 'down-angle' : 'up-angle'} />
			</button> : <Typography variant="body-2" className='font-medium text-base-grey-5'>{title}</Typography>}

			<ul
				className={cn('font-roboto flex flex-col gap-8', {
					hidden: !open,
				})}
				aria-hidden={!open}
				aria-labelledby={collapseId}
				id={sectionId}
			>
				{options.map(({ value, label, subOptions }) => (
					<li key={value}>
						<label className="flex gap-8 items-center text-lg cursor-pointer w-max text-base-grey-4">
							<CheckButton
								id={value}
								variant="xs"
								onChange={() => handleOptionChange(value, subOptions)}
								checked={selected.includes(value)}
							// onChange={() => {

							// 	if (selected.includes(value)) {
							// 		setSelected(selected.filter(w => w !== value));
							// 	} else {
							// 		setSelected([...selected, value]);
							// 	}
							// }}
							// checked={selected.includes(value)}
							/>
							{label}
						</label>
						{subOptions && selected.includes(value) && (
							<ul className={`ml-4 mt-2 ${value === 'Ensino Superior' ? 'grid grid-cols-2 gap-4' : value === 'Possui CNH' ? 'flex flex-col gap-2' : 'flex gap-4 flex-row'}`}>
								{subOptions.map(subOption => (
									<li key={subOption.value}>
										<label className="flex gap-3 items-center text-lg cursor-pointer w-max text-base-grey-4 py-5">
											<CheckButton
												id={subOption.value}
												variant="xs"
												onChange={() => handleSubOptionChange(value, subOption.value)}
												checked={selected.includes(`${value}-${subOption.value}`)}
											/>
											{subOption.label}
										</label>
									</li>
								))}
							</ul>
						)}
					</li>
				))}
			</ul>
		</div>
	);
};

export default FilterCheckboxSection;
